import ShopItemCard from './ItemCard';
import {useState, useEffect} from "react";

import _ from "lodash";
import MenuItemCard from "./MenuItemCard";

export default function ItemMenu({onClick, menuItems, groupedItems, category, subCategory, onItemsLoaded}) {

    const [filteredItems, setFilteredItems] = useState([]);

    useEffect(() => {
        // React to changes in category or subCategory

        let filteredItems = menuItems;

        if (category && category.id !== 'All Item Groups') {

            const foundGroup = _.find(groupedItems, (groups, parentGroup) => parentGroup === category.id);
            let categories = [category.id];
            if (foundGroup && foundGroup.length > 0) {
                foundGroup.forEach(element => {
                    categories.push(element.id);
                });
            }

            filteredItems = _.filter(menuItems, (item) => _.includes(categories, item.item_group));
        }

        if (subCategory) {
            filteredItems = _.filter(filteredItems, { item_group: subCategory.id });
        }

        setFilteredItems(filteredItems);

    }, [category, subCategory]);

    useEffect(() => {
        setFilteredItems(menuItems);

        if (onItemsLoaded) {
            onItemsLoaded(menuItems);
        }
    }, [menuItems]);

    return (
        <div className={'CategoryView__MainMenu'}>
            {filteredItems && filteredItems.length > 0 ? (
                filteredItems.map((entry) => <MenuItemCard key={entry.item_code} item={entry} onClick={onClick}/>)
            ) : (
                <p>No menu items available.</p>
            )}
        </div>
    );
}
